import React from "react"
import { Link } from "gatsby"
import Infolinia from "../infolinia"
// import BigLogo from "../../images/duze-logo.svg"
import BigLogo from "../../images/ocharge-logo.svg"
//import BigLogoGreen from "../../images/duze-logo-green.svg"
import { Container } from "react-bootstrap"
import scrollTo from "gatsby-plugin-smoothscroll"
import SliderDesktop from "./sliderdesktop"
import SliderMobile from "./slidermobile"
import {  BrowserView,  MobileView} from "react-device-detect"

const VisualSlider = () => {

    return (
      <section className="home-visual">
        <section className="visual-slider">
          <BrowserView>
            <SliderDesktop />
          </BrowserView>
          <MobileView>
            <SliderMobile />
          </MobileView>
          <div className="bg-overlay"></div>
        </section>
        <div className="visual-details px-3 px-xxl-5 container">
          <div className="row justify-content-lg-between align-items-center w-100 px-xxl-3 px-xxxl-5">
            <div className="col-12 col-sm-6 text-center text-md-left">
            {/* <h2 className="col-12 text-uppercase font-bold text-white mb-3 mb-md-4 dopisek">Stacje ładowania <br/>pojazdów elektrycznych</h2> */}
              <img src={BigLogo} alt="" className="img-fluid" />
            </div>
            <div className="col-12 col-sm-6 mt-5 mt-sm-0 text-center text-md-right">
              <Infolinia />
            </div>
          </div>
        </div>
        <div className="visual-details2 d-none d-md-block mb-md-5 mb-lg-0">
          <Container>
            <div className="row py-2 py-xl-3 py-xxl-5">
              <div className="col-4 text-center">
                <Link
                  to="/ladowarki"
                  title="Poznaj parametry techniczne ładowarek"
                >
                  <figure>
                    <span className="icon-icon-visual-1"></span>
                  </figure>
                  <div className="title">NASZE ŁADOWARKI</div>
                  <p>Poznaj parametry techniczne.</p>
                </Link>
              </div>
              <div className="col-4 text-center">
                <Link to="/instrukcja-ladowania" title="instrukcja-ladowania">
                  <figure>
                    <span className="icon-icon-visual-2"></span>
                  </figure>
                  <div className="title">INSTRUKCJA ŁADOWANIA</div>
                  <p>Sprawdź jakie to proste.</p>
                </Link>
              </div>
              <div className="col-4 text-center">
                <Link
                  to="/regulamin-promo"
                  title="Zapoznaj się z regulaminem usługi ładowania"
                >
                  <figure>
                    <span className="icon-icon-visual-3"></span>
                  </figure>
                  <div className="title">REGULAMIN USŁUG ŁADOWANIA</div>
                  <p>Dowiedz się więcej.</p>
                </Link>
              </div>
              {/* <div className="col-4 text-center">
                <Link
                  to="/regulamin"
                  title="Zapoznaj się z regulaminem usługi ładowania"
                >
                  <figure>
                    <span className="icon-icon-visual-3"></span>
                  </figure>
                  <div className="title">PUNKTY VITAY</div>
                  <p>Dowiedz się więcej.</p>
                </Link>
              </div> */}
            </div>
          </Container>
        </div>
        <button
          onClick={() => scrollTo("#oferta")}
          className="visual-scroller d-sm-none d-md-block d-lg-none d-xxxl-block button-blank" aria-label="przewiń"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="260"
            height="45.349"
            viewBox="0 0 260 45.349"
          >
            <g
              id="Group_18"
              data-name="Group 18"
              transform="translate(-830 -899.831)"
            >
              <path
                className="falka"
                d="M1924.4-35.058v-4.535A20.407,20.407,0,0,0,1903.988-60h-61.977A20.407,20.407,0,0,0,1821.6-39.593v4.535A20.407,20.407,0,0,1,1801.2-14.651H1743v-.012h260v.012h-58.2A20.407,20.407,0,0,1,1924.4-35.058Z"
                transform="translate(-913 959.831)"
              />
            </g>
          </svg>
          <div className="bouncer">
            <span className="icon-arr-down"></span>
          </div>
        </button>
      </section>
    )
}
export default VisualSlider



